
import { joinURL } from 'ufo';

export const getPhotoUrl = (warehousePhotos) => {
  if (!(warehousePhotos && Array.isArray(warehousePhotos))) {
    return "/img/WareX-chicklet.png";
  }
  const { url } = warehousePhotos[0] || {};
  if (url) {
    return joinURL("/api/v2", url)
  }
  return "/img/WareX-chicklet.png";
}

export const getFirstUrl = (photoUrls) => {
  if (!(photoUrls && Array.isArray(photoUrls))) {
    return "/img/WareX-chicklet.png";
  }
  let url = photoUrls[0];
  if (url && typeof(url) !== 'string') {
    url = photoUrls[0].url;
  }
  if (url) {
    return joinURL("/api/v2", url)
  }
  return "/img/WareX-chicklet.png";
}
